import React from 'react';
import { IStore } from '../../../../../redux/store';
import { ConnectedProps, connect } from 'react-redux';
import moment from 'moment';
import fuelOilTankLocationImg from '../../../../../assets/coverpages/annex6v2LocationFOT.jpg';
import classNames from 'classnames';
import { marpolSelectors } from '../../../../../redux/app/marpol';
import { TMARPOLTank } from '../../../../../redux/app/marpol/@types';
import { ODSType } from '../../../../../redux/app/marpol/@types';
import { inspectorSelectors } from 'redux/app/vessel/inspector';
import { vesselSelectors } from 'redux/app/vessel';
import TankWithPositionTable from 'components/app/vessel/onboard/inspector/_elements/TankWithPositionTable';

type OwnProps = {
    // isPrintVisible: boolean;
	vesselId: string;
};
type Annex6CoverPageProps = OwnProps & PropsFromRedux;

function IntroductionPage() {
    return (
        <div className="newpage flex flex-col justify-between py-4 px-8 mb-2 text-justify">
            <h1 className="text-xs text-center my-4 mt-8 font-semibold">
                REFER “SAMPLE ENTRIES - MARPOL ANNEX VI” IN PERIODICALLY UPDATED
                INFORMATION SECTION
            </h1>
            <h2 className="font-medium text-2xl text-center">Introduction</h2>
            <p className="my-4 mx-0">
                <ol className="list-decimal  ml-4">
                    <li className="mb-8">
                        <p className="my-2 mx-0 ml-2">
                            In accordance with MARPOL Annex VI/ Reg 12, Reg13,
                            Reg 14, Reg 18, the MARPOL Annex VI Record Book
                            enables Vessel to exhibit record keeping compliance
                            as required by
                        </p>
                        <ol className="list-alpha ml-8" type="a">
                            <li className="my-2 mx-0">
                                <span className="ml-2">
                                    Annex VI/ Reg 4 Equivalents
                                </span>
                            </li>
                            <li className="my-2 mx-0">
                                <span className="ml-2">
                                    Annex VI/ Reg 12 Ozone-depleting Substances
                                </span>
                            </li>
                            <li className="my-2 mx-0">
                                <span className="ml-2">
                                    Annex VI/ Reg 13 Nitrogen Oxides (NOx)
                                </span>
                            </li>
                            <li className="my-2 mx-0">
                                <span className="ml-2">
                                    Annex VI/ Reg 14 Sulphur Oxides (SOx) and
                                    Particulate Matter
                                </span>
                            </li>
                            <li className="my-2 mx-0">
                                <span className="ml-2">
                                    Annex VI/ Reg 18 Fuel Oil Availability and
                                    Quality
                                </span>
                            </li>
                        </ol>
                    </li>
                    <li className="mb-8">
                        <p className="my-2 mx-0 ml-2">
                            The European Community's Sulphur Content of Liquid
                            Fuels Directive 1999/32/EC, as amended by 2005/33/EC
                            of 06 July 2005 requires that ships at berth in
                            European ports do not use marine fuel with Sulphur
                            content exceeding 0.1% m/m.
                        </p>
                    </li>
                    <li className="mb-8">
                        <p className="my-2 mx-0 ml-2">
                            Entries in the MARPOL Annex VI Record Book shall be
                            made following the occasions listed on page 10 - 13.
                        </p>
                    </li>
                    <li className="mb-8">
                        <p className="my-2 mx-0 ml-2">
                            The Record Book must be properly completed. All
                            operations must be clearly and accurately recorded.
                        </p>
                    </li>
                    <li className="mb-8">
                        <p className="my-2 mx-0 ml-2">
                            The Record Book entries shall be maintained on board
                            the ship for a minimum period of three (3) years
                            after the last entry has been made. BDN must be
                            retained on board for a period of three (3) years
                            after the fuel has been delivered on board.
                        </p>
                    </li>
                </ol>
            </p>
        </div>
    );
}

function ItemsTobeRecorded(props: {
    printWithoutPageNumber: boolean;
    vesselInfo: any;
    tanks: TMARPOLTank[];
    ods: ODSType[] | undefined;
}) {
    const { printWithoutPageNumber, vesselInfo, tanks, ods } = props;
	console.log(vesselInfo);
	
    return (
        <div className={classNames('newpage mt-10 py-0 px-4', {})}>
            <div
                className={classNames('py-0 px-5 mb-2 mt-10', {
                    'h-screen': printWithoutPageNumber,
                })}
            >
                <b>AA) Control of Emissions- Ozone Depleting Substances</b>
                <p className="underline">
                    Ozone Depleting Substances (ODS) are covered under MARPOL
                    Annex VI/ Reg 12
                </p>
                <div className="my-4 mx-0">
                    <ol className="list-decimal  ml-4">
                        <li className="mb-2">
                            <p className="my-2 mx-0 ml-2">
                                This regulation does not apply to permanently
                                sealed equipment where there are no refrigerant
                                charging connections or potentially removable
                                components containing ozone-depleting
                                substances.
                            </p>
                        </li>
                        <li className="mb-2">
                            <p className="my-2 mx-0 ml-2">
                                Any deliberate emissions of ozone-depleting
                                substances shall be prohibited. Deliberate
                                emissions include emissions occurring in the
                                course of maintaining, servicing, repairing or
                                disposing of systems or equipment, except that
                                deliberate emissions do not include minimal
                                releases associated with the recapture or
                                recycling of an ozone-depleting substance.
                                Emissions arising from leaks of an
                                ozone-depleting substance, whether or not the
                                leaks are deliberate, may be regulated by
                                Parties.
                            </p>
                        </li>
                    </ol>
                    <div className="flex-col">
                        <div className="flex justify-start mb-1">
                            <div className="min-w-10 my-1 mx-0">3.1</div>
                            <div>
                                <p className="my-1 mx-0">
                                    Installations that contain ozone-depleting
                                    substances, other than
                                    hydro-chlorofluorocarbons, shall be
                                    prohibited:
                                </p>
                                <ol className="list-decimal ml-4">
                                    <li className="my-1 mx-0">
                                        on ships constructed on or after 19 May
                                        2005; or
                                    </li>
                                    <li className="my-1 mx-0">
                                        in the case of ships constructed before
                                        19 May 2005, which have a contractual
                                        delivery date of the equipment to the
                                        ship on or after 19 May 2005 or, in the
                                        absence of a contractual delivery date,
                                        the actual delivery of the equipment to
                                        the ship on or after 19 May 2005.
                                    </li>
                                </ol>
                            </div>
                        </div>
                        <div className="flex justify-start mb-1">
                            <div className="min-w-10 my-1 mx-0">3.2</div>
                            <div>
                                <p className="my-1 mx-0">
                                    Installations which contain
                                    hydrochlorofluorocarbons shall be
                                    prohibited:
                                </p>
                                <ol className="list-decimal ml-4">
                                    <li className="my-1 mx-0">
                                        on ships constructed on or after 1
                                        January 2020; or
                                    </li>
                                    <li className="my-1 mx-0">
                                        in the case of ships constructed before
                                        1 January 2020, which have a contractual
                                        delivery date of the equipment to the
                                        ship on or after 1 January 2020 or, in
                                        the absence of a contractual delivery
                                        date, the actual delivery of the
                                        equipment to the ship on or after 1
                                        January 2020.
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <ol className="list-decimal  ml-4" start={4}>
                        <li className="mb-2">
                            <p className="my-2 mx-0 ml-2">
                                The substances referred to in this regulation,
                                and equipment containing such substances, shall
                                be delivered to appropriate reception facilities
                                when removed from ships.
                            </p>
                        </li>
                        <li className="mb-2">
                            <p className="my-2 mx-0 ml-2">
                                Vessel shall maintain a list of equipment
                                containing ozone-depleting substances.
                            </p>
                        </li>
                        <li className="mb-2">
                            <p className="my-2 mx-0 ml-2">
                                Vessel that has rechargeable systems that
                                contain ozone-depleting substances shall
                                maintain an ozone-depleting substances record
                                book. This record book may form part of an
                                existing logbook or electronic recording system
                                as approved by the Administration.
                            </p>
                        </li>
                        <li className="mb-2">
                            <b>Record Keeping</b>
                            <p className="my-2 mx-0 ml-2">
                                Entries shall be recorded in terms of mass (kg)
                                of substance and shall be completed without
                                delay on each occasion, in respect of the
                                following
                            </p>
                            <ol className="list-decimal  ml-8">
                                <li>
                                    <p className="my-1 mx-0 ml-2">
                                        recharge, full or partial, of equipment
                                        containing ozone-depleting substances.
                                    </p>
                                </li>
                                <li>
                                    <p className="my-1 mx-0 ml-2">
                                        repair or maintenance of equipment
                                        containing ozone-depleting substances.
                                    </p>
                                </li>
                                <li>
                                    <p className=" mx-0 ml-2">
                                        discharge of ozone-depleting substances
                                        to the atmosphere:
                                    </p>
                                    <div className="flex justify-start ">
                                        <div className="min-w-10 mb-1  mx-0">
                                            3.1
                                        </div>
                                        <div>
                                            <p className="mb-1 mx-0">
                                                deliberate
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex justify-start ">
                                        <div className="min-w-10 mb-1 mx-0">
                                            3.2
                                        </div>
                                        <div>
                                            <p className="mb-1 mx-0">
                                                non-deliberate
                                            </p>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <p className="my-1 mx-0 ml-2">
                                        discharge of ozone-depleting substances
                                        to land-based reception facilities
                                    </p>
                                </li>
                                <li>
                                    <p className="my-1 mx-0 ml-2">
                                        supply of ozone-depleting substances to
                                        the ship.
                                    </p>
                                </li>
                            </ol>
                        </li>
                    </ol>
                </div>
            </div>

            <div className="py-0 px-5 mb-2 mt-10 newpage">
                <div>
                    <b>BB) Control of Emissions- Nitrogen Oxides</b>
                    <p className="underline">
                        Nitrogen Oxides emission from ships is covered under
                        MARPOL Annex VI/ Reg 13
                    </p>
                    <div className="my-4 mx-0">
                        <p className="my-2 mx-0 ">
                            The below restriction does NOT apply to (a)
                            Emergency Diesel Generator, (b) any device/equipment
                            intended to be used solely for emergency and (c)
                            Lifeboat engine.
                        </p>
                        <p className="my-2 mx-0 ">
                            Marine diesel engines with an output &gt; 130kW,
                            shall have emission of NO2 (calculated as total
                            weighted emission of NO2) from engines within
                            following limit:
                        </p>
                        <div>
                            <table className="border-collapse border print:border-black w-full my-8">
                                <thead>
                                    <tr>
                                        <th
                                            className="border print:border-black p-1.5 text-gray-700 font-medium "
                                            rowSpan={2}
                                        >
                                            Tier
                                        </th>
                                        <th
                                            className="border print:border-black p-1.5 text-gray-700 font-medium "
                                            rowSpan={2}
                                        >
                                            Construction Date
                                        </th>
                                        <th
                                            className="border print:border-black p-1.5 text-gray-700 font-medium  text-center"
                                            colSpan={3}
                                        >
                                            Total engine weighted cycle emission
                                            of NO2 (g/kWh)(n = rpm)
                                        </th>
                                    </tr>
                                    <tr>
                                        <th className="border print:border-black p-1.5 text-gray-700 font-normal ">
                                            n &lt; 130
                                        </th>
                                        <th className="border print:border-black p-1.5 text-gray-700 font-normal ">
                                            130 &lt; n &lt; 1999
                                        </th>
                                        <th className="border print:border-black p-1.5 text-gray-700 font-normal ">
                                            n &gt; 2000
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="border print:border-black p-1.5 text-gray-700 font-normal text-center">
                                            See Note (1)
                                        </td>
                                        <td className="border print:border-black p-1.5 text-gray-700 font-normal text-center">
                                            01 Jan 1990-31 Dec 1999
                                        </td>
                                        <td className="border print:border-black p-1.5 text-gray-700 font-normal text-center">
                                            17
                                        </td>
                                        <td className="border print:border-black p-1.5 text-gray-700 font-normal text-center">
                                            45 x n<sup>-0.2</sup>
                                        </td>
                                        <td className="border print:border-black p-1.5 text-gray-700 font-normal text-center">
                                            9.8
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="border print:border-black p-1.5 text-gray-700 font-normal text-center">
                                            I
                                        </td>
                                        <td className="border print:border-black p-1.5 text-gray-700 font-normal text-center">
                                            01 Jan 2000 - 31 Dec 2010
                                        </td>
                                        <td className="border print:border-black p-1.5 text-gray-700 font-normal text-center">
                                            17
                                        </td>
                                        <td className="border print:border-black p-1.5 text-gray-700 font-normal text-center">
                                            45 x n<sup>-0.2</sup>
                                        </td>
                                        <td className="border print:border-black p-1.5 text-gray-700 font-normal text-center">
                                            9.8
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="border print:border-black p-1.5 text-gray-700 font-normal text-center">
                                            II
                                        </td>
                                        <td className="border print:border-black p-1.5 text-gray-700 font-normal text-center">
                                            After 01 Jan 2011
                                        </td>
                                        <td className="border print:border-black p-1.5 text-gray-700 font-normal text-center">
                                            14.4
                                        </td>
                                        <td className="border print:border-black p-1.5 text-gray-700 font-normal text-center">
                                            44 x n<sup>-0.23</sup>
                                        </td>
                                        <td className="border print:border-black p-1.5 text-gray-700 font-normal text-center">
                                            7.7
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="border print:border-black p-1.5 text-gray-700 font-normal text-center">
                                            III
                                        </td>
                                        <td className="border print:border-black p-1.5 text-gray-700 font-normal text-center">
                                            <p>
                                                After 01 Jan 2016{' '}
                                                <sup> See Note (2)</sup>
                                            </p>
                                            <p>
                                                After 01 Jan 2021{' '}
                                                <sup>See Note (3)</sup>
                                            </p>
                                        </td>
                                        <td className="border print:border-black p-1.5 text-gray-700 font-normal text-center">
                                            3.4
                                        </td>
                                        <td className="border print:border-black p-1.5 text-gray-700 font-normal text-center">
                                            9 x n<sup>-0.2</sup>
                                        </td>
                                        <td className="border print:border-black p-1.5 text-gray-700 font-normal text-center">
                                            2.0
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="my-2 mx-0 ">
                            <p className="my-1 mx-0">
                                Note (1) for Diesel engine output &gt; 5,000 kW
                                and per cylinder displacement at or above 90L.
                            </p>
                            <p className="my-1 mx-0">
                                Note (2) for ships operating in North American
                                ECA or US Caribbean Sea ECA
                            </p>
                            <p className="my-1 mx-0">
                                Note (3) for ships operating in Baltic Sea ECA
                                or North Sea ECA
                            </p>
                        </div>
                    </div>
                </div>
                {/* end of bb */}
            </div>

            <div className="py-0 px-5 mb-2 mt-10 newpage">
                {/* start of cc */}
                <b>CC) Control of Emissions-Sulphur content </b>
                <p className="underline">
                    Sulphur content of fuel being used on ships is covered under
                    MARPOL Annex VI/ Reg 14
                </p>
                <div className="my-4 mx-0">
                    <b>Permissible Sulphur content of marine fuel oil</b>
                    <p className="my-1 mx-0 ">
                        Outside ECA: Max permissible Sulphur content (as per
                        BDN) is 0.5% m/m
                    </p>
                    <p className="my-1 mx-0 ">
                        Inside ECA: Max permissible Sulphur content (as per BDN)
                        is 0.10% m/m
                    </p>
                    <p className="my-1 mx-0 ">
                        OR an Equivalent Arrangement that effectively reduces
                        SOx emission as compared to above fuel oil.
                    </p>
                    <div className="my-2 mx-0 ">
                        <p className="my-1 mx-0">
                            MARPOL Annex VI allows the use of an alternative
                            compliance method at least as effective in terms of
                            emission reductions as that required by MARPOL Annex
                            VI. Compliance can be achieved using low Sulphur
                            fuel, LNG fuel or by cleaning exhaust gases using
                            scrubbers (Exhaust Gas Cleaning system).
                        </p>
                        <p className="my-1 mx-0">
                            Apart from this, countries may implement stricter
                            requirements in areas of their jurisdiction which is
                            in addition to MARPOL.
                        </p>
                    </div>
                </div>
                <div className="mb-2">
                    <b>Record Keeping</b>
                    <p className="my-2 mx-0 ml-2">
                        Ships using separate fuel oils to comply with the
                        requirements shall
                    </p>
                    <ol className="list-decimal  ml-8">
                        <li>
                            <p className="my-2 mx-0 ml-2">
                                carry a written procedure showing how the fuel
                                oil change-over is to be done, allowing
                                sufficient time for the fuel oil service system
                                to be fully flushed of all fuel oils exceeding
                                the applicable Sulphur content prior to entry
                                into an emission control area.
                            </p>
                        </li>
                        <li>
                            <p className="my-2 mx-0 ml-2">
                                Volume of low Sulphur fuel oils in each tank as
                                well as the date, time, and position of the ship
                                shall be recorded in after any
                                fuel-oil-change-over operation, i.e.
                            </p>
                            <ol className="list-alpha ml-4" type="a">
                                <li className="my-1 mx-0">
                                    Completion of changeover prior to the entry
                                    into an ECA
                                </li>
                                <li className="my-1 mx-0">
                                    Commencing fuel changeover after exiting an
                                    ECA
                                </li>
                            </ol>
                        </li>
                    </ol>
                </div>
                {/* end of cc */}
            </div>
            <div
                className={classNames('py-0 px-5 mb-2 mt-10 newpage', {
                    'h-screen': printWithoutPageNumber,
                })}
            >
                <b>DD) Fuel Oil availability and Quality </b>
                <p className="underline">
                    Fuel Oil Availability and Quality covered under MARPOL Annex
                    VI/ Reg 18
                </p>
                <div className="my-4 mx-0">
                    <b>Fuel Oil Availability</b>
                    <p className="my-2 mx-0 ">
                        If a vessel for some reason in not in compliance with
                        standards for compliant fuel oils, it should have:
                    </p>
                    <ol className="list-decimal  ml-4">
                        <li className="mb-2">
                            <p className="my-2 mx-0 ml-2">
                                record of the actions taken to attempt to
                                achieve compliance; and
                            </p>
                        </li>
                        <li className="mb-2">
                            <p className="my-2 mx-0 ml-2">
                                provide evidence that it attempted to purchase
                                compliant fuel oil in accordance with its voyage
                                plan and, if it was not made available where
                                planned, that attempts were made to locate
                                alternative sources for such fuel oil and that
                                despite best efforts to obtain compliant fuel
                                oil, no such fuel oil was made available for
                                purchase.
                            </p>
                        </li>
                    </ol>
                    <p className="my-2 mx-0">
                        Vessel is not required to deviate from its intended
                        voyage or to delay unduly the voyage in order to achieve
                        compliance. Flag and the competent authority of the
                        relevant port of destination shall be notified in
                        advance when vessel does not have compliant fuel oil.
                    </p>
                </div>
                <div className="my-4 mx-0">
                    <b>Fuel Oil Quality</b>
                    <p className="my-2 mx-0 ">
                        Fuel oil for combustion purposes delivered to and used
                        on board ships to which this Annex applies shall meet
                        the following requirements:
                    </p>
                    <ol className="list-decimal  ml-4">
                        <li className="mb-2">
                            <p className="my-2 mx-0 ml-2">
                                Fuel oil shall, except as provided in paragraph
                                .2 of this regulation:
                            </p>
                            <ol className="list-disc  ml-4">
                                <li className="mb-2">
                                    <p className="my-2 mx-0 ml-2">
                                        be blends of hydrocarbons derived from
                                        petroleum refining (small amounts of
                                        additives intended to improve some
                                        aspects of performance is permitted)
                                    </p>
                                </li>
                                <li className="mb-2">
                                    <p className="my-2 mx-0 ml-2">
                                        free from inorganic acid; and
                                    </p>
                                </li>
                                <li className="mb-2">
                                    <p className="my-2 mx-0 ml-2">
                                        not include any added substance or
                                        chemical waste that jeopardizes the
                                        safety of ships or adversely affects the
                                        performance of the machinery, or is
                                        harmful to personnel, or contributes
                                        overall to additional air pollution.
                                    </p>
                                </li>
                            </ol>
                        </li>
                        <li className="mb-2">
                            <p className="my-2 mx-0 ml-2">
                                fuel oil for combustion purposes derived by
                                methods other than petroleum refining shall not:
                            </p>
                            <ol className="list-disc  ml-4">
                                <li className="mb-2">
                                    <p className="my-2 mx-0 ml-2">
                                        exceed the applicable sulphur content or
                                        cause an engine to exceed the applicable
                                        NOx emission limit.
                                    </p>
                                </li>
                                <li className="mb-2">
                                    <p className="my-2 mx-0 ml-2">
                                        contain inorganic acid; or
                                    </p>
                                </li>
                                <li className="mb-2">
                                    <p className="my-2 mx-0 ml-2">
                                        jeopardize the safety of ships or
                                        adversely affect the performance of the
                                        machinery, or be harmful to personnel,
                                        or contribute overall to additional air
                                        pollution.
                                    </p>
                                </li>
                            </ol>
                        </li>
                    </ol>
                </div>
                <div className="mb-2">
                    <b>Record Keeping</b>
                    <ol className="list-disc  ml-8">
                        <li>
                            <p className="my-2 mx-0 ml-2">
                                Fuel sample (sealed and signed by supplier as
                                well as master or officer in charge of the
                                bunker operation on vessel) shall be retained on
                                board until it is substantially consumed, but
                                not less than 12 months from supply date.
                            </p>
                        </li>
                        <li>
                            <p className="my-2 mx-0 ml-2">
                                Fuel Oil shall be accompanied by bunker delivery
                                note (BDN) which shall be retained for a period
                                of three years after the fuel oil has been
                                delivered on board.
                            </p>
                        </li>
                        <li>
                            <p className="my-2 mx-0 ml-2">
                                Fuel Oil Non-Availability Report (FONAR)- to be
                                retained for at least 12 months.
                            </p>
                        </li>
                    </ol>
                </div>
            </div>

            <div className="py-0 px-5 mb-2 mt-10 newpage">
                <p className="text-center">
                    <b>GENERAL INSTRUCTIONS</b>
                </p>
                <p className="my-4 mx-0">
                    Complete the diagram on page{' '}
                    {printWithoutPageNumber ? 7 : 8}, identifying the ships fuel
                    tanks and their capacities in cubic meters. The ship is to
                    add the Fuel oil system piping diagram, General arrangement
                    and Capacity plan with this record book.
                </p>

                <p className="my-4 mx-0">
                    Page 10 - 13 contains the list of operations which are, when
                    appropriate, to be recorded in the MARPOL Annex VI Record
                    Book. Each operation shall be fully recorded without delay.
                </p>
                <p className="my-4 mx-0">
                    When making entries in the Marine Sulphur Record Book, the
                    date (dd-MMM-yyyy format, e.g., 01-JUL- 2023) and item
                    number shall be inserted in the appropriate columns and the
                    required particulars shall be recorded chronologically in
                    the blank spaces. The Record Book shall be maintained in the
                    English language.
                </p>
                <p className="my-4 mx-0">
                    The items have been grouped into operational sections, each
                    of which is denoted by an item number. Record book is made
                    to reflect record keeping requirements using Code Letter and
                    Item Number to eliminate unused pages and extend the time
                    period covered by a single record book.
                </p>
                <p className="my-4 mx-0">
                    Each entry shall be signed and dated by the officer in
                    charge of the operation concerned. Each completed page shall
                    be countersigned by the Master of the ship.
                </p>
                <p className="my-4 mx-0">
                    Do not leave any full lines empty between entries
                </p>
                <p className="my-4 mx-0">
                    If a wrong entry has been recorded, it should immediately be
                    struck through with a single line in such a way that the
                    wrong entry is still legible. The wrong entry should be
                    signed and dated, with the new corrected entry made
                    following the wrong entry.
                </p>
                <p className="my-4 mx-0">
                    If, at a later date, Record Book entries are found to be in
                    error or require to be clarified (such as during an audit or
                    internal review) and the Officer who completed the original
                    operation and/or the erratic entry is not on board anymore,
                    a correct entry to be made under code 'K' and signed by
                    onboard CE and Master. A note of the relevant findings to be
                    attached with initial erroneous entry [reflecting the date
                    of correct entry].
                </p>
                <p className="my-4 mx-0">
                    If Fuel oil changeover is not undertaken prior to entry in
                    ECA area i.e. if the Master reasonably decides that such
                    exchange would threaten the safety of the ship, its crew, or
                    its passengers because of adverse weather, fuel
                    unavailability, equipment failure, or any other
                    extraordinary condition, then details of the reasons the
                    changeover was not undertaken are to be recorded in the
                    Record Book.
                </p>
                <p className="my-4 mx-0">
                    The Record Book shall be kept in such a place as to be
                    readily available for inspection at all reasonable times.
                </p>
            </div>

            {/* Equipment containing ods */}
            <div className="py-0 px-5 mb-2 mt-10 newpage">
                <h3 className="font-medium text-base text-center">
                    List of System/ Equipment Containing Ozone Depleting
                    Substances
                </h3>
                <p className="text-center">(to be completed on board)</p>

                <div>
                    <div
                        className="flex items-center mb-4"
                        style={{ fontSize: '1.125rem' }}
                    >
                        <p className="mb-0 mr-2 text-base min-w-fit">
                            Name of the vessel
                        </p>
                        <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end text-sm">
                            {vesselInfo?.vesselName}
                        </p>
                    </div>
                    <div
                        className="flex items-center mb-4"
                        style={{ fontSize: '1.125rem' }}
                    >
                        <p className="mb-0 mr-2 text-base min-w-fit">
                            IMO Number
                        </p>
                        <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end text-sm">
                            {vesselInfo?.imoNumber}
                        </p>
                    </div>
                </div>

                <table className="border-collapse border w-full my-8">
                    <thead>
                        <tr>
                            <th className="border p-1.5 text-gray-700 font-medium ">
                                System
                            </th>
                            <th className="border p-1.5 text-gray-700 font-medium ">
                                Location
                            </th>
                            <th className="border p-1.5 text-gray-700 font-medium  text-center">
                                ODS Used
                            </th>
                            <th className="border p-1.5 text-gray-700 font-medium  text-center">
                                Initial System Charge (kg)
                            </th>
                            <th className="border p-1.5 text-gray-700 font-medium  text-center">
                                Date of Confirmation
                            </th>
                            <th className="border p-1.5 text-gray-700 font-medium  text-center">
                                Sign
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {ods && ods.length > 0 ? (
                            <>
                                {ods.map((odsRecord, index) => {
                                    return (
                                        <tr key={index}>
                                            <td className="border p-6 text-gray-700 font-normal text-center">
                                                {odsRecord.system}
                                            </td>
                                            <td className="border p-6 text-gray-700 font-normal text-center">
                                                {odsRecord.location}
                                            </td>
                                            <td className="border p-6 text-gray-700 font-normal text-center">
                                                {odsRecord.odsUsed}
                                            </td>
                                            <td className="border p-6 text-gray-700 font-normal text-center">
                                                {odsRecord.initialCharge}
                                            </td>
                                            <td className="border p-6 text-gray-700 font-normal text-center">
                                                {moment(
                                                    odsRecord.confirmationDate
                                                ).format('DD-MMM-yyyy')}
                                            </td>
                                            <td className="border p-6 text-gray-700 font-normal text-center">
                                                {odsRecord.sign?.name}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </>
                        ) : (
                            <>
                                {Array.from({ length: 8 }).map((_, i) => (
                                    <tr key={i}>
                                        <td className="border p-6 text-gray-700 font-normal text-center"></td>
                                        <td className="border p-6 text-gray-700 font-normal text-center"></td>
                                        <td className="border p-6 text-gray-700 font-normal text-center"></td>
                                        <td className="border p-6 text-gray-700 font-normal text-center"></td>
                                        <td className="border p-6 text-gray-700 font-normal text-center"></td>
                                        <td className="border p-6 text-gray-700 font-normal text-center"></td>
                                    </tr>
                                ))}
                            </>
                        )}
                    </tbody>
                </table>

                <div>
                    <h4 className="font-medium text-base text-center">
                        DIAGRAM OF SHIP INDICATING LOCATION OF FUEL OIL TANKS
                    </h4>
                    <p className="text-center">(to be completed on board)</p>

                    <img
                        src={fuelOilTankLocationImg}
                        alt="Location of Fuel oil tank"
                    />
                </div>
            </div>

            <div className="py-0 px-5 mb-2 mt-10 newpage">
                <div className="flex flex-wrap space-x-4 justify-evenly">
                    <TankWithPositionTable
                        tanks={tanks?.slice(0, tanks?.length / 2)}
                        hidePositionCol
                    />
                    <TankWithPositionTable
                        tanks={tanks?.slice(tanks?.length / 2)}
                        hidePositionCol
                    />
                </div>
            </div>

            {/* Items to be recorded */}
            {/* Points A, B & C */}
            <div
                className={classNames('py-0 px-5 mb-2  newpage', {
                    'mt-16': printWithoutPageNumber,
                })}
            >
                <h3 className="capitalize font-medium text-base text-center">
                    List of items to be recorded
                </h3>
                <p className="my-2 mx-0 text-xs">
                    NOTE: The quantity of Fuel Oil onboard should be recorded in
                    MT (except individual tank quantity should be recorded in M3
                    while changing over fuel while entering or leaving emission
                    control area). Entries in the Marine Sulphur record book
                    shall be made on each of the following occasions:
                </p>
                <ol className="list-alpha ml-4" type="A">
                    {/* Point A */}
                    <li className="mb-8">
                        <b>
                            Equipment containing Ozone Depleting Substances
                            (ODS)- Release / recharge / supply / discharge
                            ashore
                        </b>
                        <ol className="list-decimal ml-4">
                            <li className="my-2 mx-0">
                                Identification of system containing ODS along
                                with type of ODS and Initial charge of the
                                system (in kgs)
                            </li>
                            <li className="my-2 mx-0">
                                Date and time of occurrence
                            </li>
                            <li className="my-2 mx-0">
                                <span>Activity</span>
                                <ol className="list-decimal ml-4">
                                    <li className="my-1 mx-0">
                                        Recharge (full or Partial) - 7KG
                                    </li>
                                    <li className="my-1 mx-0">
                                        Repair or Maintenance
                                    </li>
                                    <li className="my-1 mx-0">
                                        Deliberate discharge to Atmosphere
                                    </li>
                                    <li className="my-1 mx-0">
                                        Non-deliberate discharge to atmosphere
                                    </li>
                                    <li className="my-1 mx-0">
                                        Discharge to land-based facility.
                                    </li>
                                    <li className="my-1 mx-0">
                                        Supply of ODS to Ship
                                    </li>
                                </ol>
                            </li>
                            <li className="my-2 mx-0">
                                Charge added or removed (kgs) and final charge
                                of the system (kgs).
                            </li>
                            <li className="my-2 mx-0">
                                Signature of the officer in charge of the
                                operation
                            </li>
                        </ol>
                    </li>

                    {/* Point B */}
                    <li className="mb-8">
                        <b>
                            Status of Marine Diesel Engine in NOx TIER III
                            Emission Control Area [Ship certified for Tier II or
                            Tier III or both]
                        </b>
                        <ol className="list-decimal ml-4">
                            <li className="my-2 mx-0">
                                <span>
                                    Date, time and position of ship when
                                </span>
                                <ol className="list-decimal ml-4">
                                    <li className="my-1 mx-0">
                                        Entering NOx Tier III ECA
                                    </li>
                                    <li className="my-1 mx-0">
                                        Exiting NOx Tier III ECA
                                    </li>
                                    <li className="my-1 mx-0">
                                        status of Engine(s) was/were changed
                                        ON/OFF within NOx TIER III ECA
                                    </li>
                                </ol>
                            </li>
                            <li className="my-2 mx-0">
                                Status of ON/OFF of all applicable engines and
                                their SCR/EGR equipment (In the ECA, always
                                stays ON, both are possible)
                            </li>
                            <li className="my-2 mx-0">
                                Signature of the officer in charge of the
                                operation
                            </li>
                        </ol>
                    </li>

                    {/* Point C */}
                    <li className="mb-8">
                        <b>
                            Low Sulphur Fuel Oil Change Over Record [SECA,
                            NA-ECA, Mediterranean Sea ECA or Local ECA]
                        </b>
                        <ol className="list-decimal ml-4">
                            <li className="my-2 mx-0">
                                Date, time and position (Lat / Long) of vessel
                                when changeover is commenced [prior to entry OR
                                after exiting].
                            </li>
                            <li className="my-2 mx-0">
                                Fuel oil ROBs (in M3) & BDN Sulphur content in
                                all tanks at commencement of changeover [prior
                                to entry OR after exiting].
                            </li>
                            <li className="my-2 mx-0">
                                Date, time and position (Lat / Long) of vessel
                                when changeover is completed [prior entry or
                                after exiting]
                            </li>
                            <li className="my-2 mx-0">
                                Fuel oil ROBs & BDN Sulphur content in all tanks
                                at completion of changeover [prior entry or
                                after exiting].
                            </li>
                            <li className="my-2 mx-0">
                                Date and time of actual Entering into OR Exiting
                                ECA
                            </li>
                            <li className="my-2 mx-0">
                                Signature of the officer in charge of the
                                operation
                            </li>
                        </ol>
                    </li>
                </ol>
            </div>

            {/* Points D, E, F & G */}
            <div className="py-0 px-5 mb-2 mt-10 newpage">
                <ol className="list-alpha ml-4" type="A" start={4}>
                    {/* Point D */}
                    <li className="mb-8">
                        <b>Ports and berths requiring fuel changeover:</b>
                        <ol className="list-decimal ml-4">
                            <li className="my-2 mx-0">
                                Port & Berth or position of the ship.
                            </li>
                            <li className="my-2 mx-0">
                                Date and time of arrival at berth.
                            </li>
                            <li className="my-2 mx-0">
                                Date and time of Commencement and Completion of
                                fuel changeover
                            </li>
                            <li className="my-2 mx-0">
                                Date and time of departure from the berth.
                            </li>
                            <li className="my-2 mx-0">
                                Date and time of Commencement and Completion of
                                fuel changeover
                            </li>
                            <li className="my-2 mx-0">
                                Fuel Oil consumed details: Fuel bunkered port
                                and date, corresponding BDN number, BDN Sulphur
                                content (%m/m), quantity
                            </li>
                            <li className="my-2 mx-0">
                                Signature of officer in charge of the operation
                            </li>
                        </ol>
                    </li>

                    {/* Point E */}
                    <li className="mb-8">
                        <b>
                            Exhaust gas cleaning system (EGCS) change of
                            settings for Sulphur Emission Control Area (SECA)
                            entry and exit:
                        </b>
                        <ol className="list-decimal ml-4">
                            <li className="my-2 mx-0">
                                Change of settings on EGCS when entering or
                                exiting a SECA
                            </li>
                            <li className="my-2 mx-0">
                                <span>Date, time and Position of the ship</span>
                                <ol className="list-decimal ml-4">
                                    <li className="my-2 mx-0">
                                        When Entering SECA [prior entering]
                                    </li>
                                    <li className="my-2 mx-0">
                                        When Exiting SECA [after exiting]
                                    </li>
                                </ol>
                            </li>

                            <li className="my-2 mx-0">
                                Signature of the officer in charge of the
                                operation
                            </li>
                        </ol>
                    </li>

                    {/* Point F */}
                    <li className="mb-8">
                        <b>
                            Bunker Details [in addition to code H entry required
                            in ORB part I ]
                        </b>
                        <ol className="list-decimal ml-4">
                            <li className="my-2 mx-0">
                                Date, time and port bunkering carried out.
                            </li>
                            <li className="my-2 mx-0">
                                Fuel oil grade, quantity (MT) and Sulphur
                                content (%m/m) as per BDN
                            </li>
                            <li className="my-2 mx-0">
                                Fuel bunkered to Tanks and quantities.
                            </li>
                            <li className="my-2 mx-0">
                                Suppliers and bunker delivery barge/truck
                                details
                            </li>
                            <li className="my-2 mx-0">
                                Signature of the officer in charge of the
                                operation
                            </li>
                        </ol>
                    </li>

                    {/* Point G */}
                    <li className="mb-8">
                        <b>
                            MARPOL fuel oil Sample -Receipt & Disposal [Until
                            substantially consumed, but at least 12m from
                            bunkering]:
                        </b>
                        <ol className="list-decimal ml-4">
                            <li className="my-2 mx-0">
                                Date and time of bunkering operation
                            </li>
                            <li className="my-2 mx-0">
                                MARPOL Sample seal number
                            </li>
                            <li className="my-2 mx-0">
                                Date Fuel oil fully consumed.
                            </li>
                            <li className="my-2 mx-0">
                                Date MARPOL Sample disposed and method of
                                disposal.
                            </li>
                            <li className="my-2 mx-0">
                                Signature of the officer in charge of the
                                operation [receipt / disposal]
                            </li>
                        </ol>
                    </li>
                </ol>
            </div>

            {/* Points H, I, J & K */}
            <div className="py-0 px-5 mb-2 mt-10 newpage">
                <ol className="list-alpha ml-4" type="A" start={8}>
                    {/* Point H */}
                    <li className="mb-8">
                        <b>
                            BDN Tracking -Receipt & Disposal [Retention is 3
                            years from bunkering]:
                        </b>
                        <ol className="list-decimal ml-4">
                            <li className="my-2 mx-0">
                                Date and time of bunkering operation
                            </li>
                            <li className="my-2 mx-0">
                                BDN number and any specific details as per BDN
                            </li>
                            <li className="my-2 mx-0">
                                Date BDN disposed/removed from record.
                            </li>
                            <li className="my-2 mx-0">
                                Signature of the officer in charge of the
                                operation
                            </li>
                        </ol>
                    </li>

                    {/* Point I */}
                    <li className="mb-8">
                        <b>
                            Transfer of Custody of MARPOL fuel oil Sample [to
                            third party, such as port state or other officials]:
                        </b>
                        <ol className="list-decimal ml-4">
                            <li className="my-2 mx-0">
                                Details of Custody transfer [retain transfer
                                receipt]
                                <ol className="list-decimal ml-4">
                                    <li className="my-2 mx-0">
                                        Reason for Custody Transfer
                                    </li>
                                    <li className="my-2 mx-0">
                                        Receiver Name, Designation, Address,
                                        Contact details.
                                    </li>
                                </ol>
                            </li>
                            <li className="my-2 mx-0">
                                Details of Sample
                                <ol className="list-decimal ml-4">
                                    <li className="my-2 mx-0">
                                        Date, time and port of bunkering
                                    </li>
                                    <li className="my-2 mx-0">
                                        Sample date, BDN number and Fuel oil
                                        grade
                                    </li>
                                    <li className="my-2 mx-0">
                                        BDN number & Sample Seal Number
                                    </li>
                                </ol>
                            </li>
                            <li className="my-2 mx-0">
                                Signature of the officer in charge of the
                                operation
                            </li>
                        </ol>
                    </li>

                    {/* Point J */}
                    <li className="mb-8">
                        <b>Exhaust Gas Cleaning System Sensor Failure:</b>
                        <ol className="list-decimal ml-4">
                            <li className="my-2 mx-0">
                                Port or position of the ship at time of EGCS
                                sensor failure
                            </li>
                            <li className="my-2 mx-0">
                                Is EGCS performance verifiable by other
                                parameters to indicate compliant operation?
                                [Yes/No, if No then make entry under 'K']
                            </li>
                            <li className="my-2 mx-0">
                                Sulphur content of fuel grades used in affected
                                EGCS unit.
                            </li>
                            <li className="my-2 mx-0">
                                Flag state informed of EGCS Sensor failure?
                                (Yes/No)
                            </li>
                            <li className="my-2 mx-0">
                                Date and time when EGCS sensor made operational.
                            </li>
                            <li className="my-2 mx-0">
                                Signature of officer in charge of the operation
                            </li>
                        </ol>
                    </li>

                    {/* Point K */}
                    <li className="mb-8">
                        <b>
                            Exhaust Gas Cleaning System malfunction / failure:
                        </b>
                        <ol className="list-decimal ml-4">
                            <li className="my-2 mx-0">
                                Port or position of the ship at time of EGCS
                                malfunction failure
                            </li>
                            <li className="my-2 mx-0">
                                Date and time of commence of changeover to
                                compliant fuel.
                            </li>
                            <li className="my-2 mx-0">
                                Date and time of completion of changeover to
                                compliant fuel
                            </li>
                            <li className="my-2 mx-0">
                                Coastal state and Flag state informed of EGCS
                                malfunction? (Yes/No)
                            </li>
                            <li className="my-2 mx-0">
                                Date and time when EGCS is made operational
                            </li>
                            <li className="my-2 mx-0">
                                Signature of officer in charge of the operation
                            </li>
                        </ol>
                    </li>
                </ol>
            </div>

            {/* Points L & M */}
            <div className="py-0 px-5 mb-2 mt-10 newpage">
                <ol className="list-alpha ml-4" type="A" start={12}>
                    {/* Point L */}
                    <li className="mb-8">
                        <b>
                            Record of any accidental or exceptional operation or
                            any exemptions granted by Flag:
                        </b>
                        <ol className="list-decimal ml-4">
                            <li className="my-2 mx-0">
                                <p className="my-2 mx-0">
                                    Any other accidental or exceptional
                                    operation not otherwise exempted by the
                                    Convention, describing the circumstances of,
                                    and the reason for, the discharge/exemption.
                                </p>
                                <p className="my-2 mx-0">
                                    Any exemption for FONAR- Fuel Oil
                                    Non-Availability Report granted to the ship
                                    shall also be recorded. Summary should
                                    include:
                                </p>
                                <ol className="list-disc ml-4">
                                    <li className="my-2 mx-0">
                                        actions taken to attempt to achieve
                                        compliance; and
                                    </li>
                                    <li className="my-2 mx-0">
                                        evidence of attempt to purchase
                                        compliant fuel.
                                    </li>
                                </ol>
                            </li>

                            <li className="my-2 mx-0">
                                Signature of the officer in charge of the
                                operation
                            </li>
                        </ol>
                    </li>

                    {/* Point M */}
                    <li className="mb-8">
                        <b>Additional Measures and general remarks:</b>
                        <p className="my-2 mx-0">
                            If additional measures apply to the ship and are
                            taken into account in the ship's voyage planning,
                            the actions taken to comply with these additional
                            measures should be recorded.
                        </p>
                    </li>
                </ol>
            </div>
        </div>
    );
}

function Annex6V2CoverPage(props: Annex6CoverPageProps) {
    const { vesselInfo, dateRange, tanks, stateOfScriptInjection, ods} = props;
    const { vesselName, imoNumber, tonnage, flag, distinctiveNumberOrLetters } =
        vesselInfo;

    // returns the cover page for the marpol oil record book 1

    return (
        <div>
            <div
                className={classNames(
                    'flex flex-col justify-between py-4 px-8 mb-2',
                    {
                        'h-screen': stateOfScriptInjection === 'IDLE',
                    }
                )}
            >
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '2rem',
                        marginBottom: '10rem',
                    }}
                    className="flex justify-center  mb-16 mt-24"
                >
                    <div className="w-2/3 mt-2.5">
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Name of ship:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed text-sm border-[#808080] w-full mb-0">
                                {vesselName}
                            </p>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">
                                Distinctive number or letters:
                            </p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed text-sm border-[#808080] w-full mb-0 self-end">
                                {distinctiveNumberOrLetters}
                            </p>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">IMO Number:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed text-sm border-[#808080] w-full mb-0">
                                {imoNumber}
                            </p>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Flag:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed text-sm border-[#808080] w-full mb-0">
                                {flag}
                            </p>
                        </div>

                        <div
                            style={{ fontSize: '1.125rem' }}
                            className="flex items-center mb-4"
                        >
                            <p className="mr-2 min-w-fit mb-0">
                                Gross tonnage:
                            </p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed text-sm border-[#808080] w-full mb-0 self-end">
                                {tonnage?.grossTonnage || ''}
                            </p>
                        </div>
                        <div
                            className="flex justify-between items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <div
                                style={{ width: '54%' }}
                                className="flex items-center  mb-2"
                            >
                                <p className="mr-2 min-w-fit">Period from :</p>
                                <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 text-sm">
                                    {dateRange?.startDate &&
                                        moment(dateRange?.startDate).format(
                                            'DD-MM-yyyy'
                                        )}{' '}
                                </p>
                            </div>
                            <div
                                style={{ width: '45%' }}
                                className="flex items-center mb-2"
                            >
                                <p className="mr-2 min-w-fit">to :</p>
                                <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 text-sm">
                                    {dateRange?.endDate &&
                                        moment(dateRange?.endDate).format(
                                            'DD-MM-yyyy'
                                        )}
                                </p>
                            </div>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">
                                Make Engine [Make & Model]:
                            </p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed text-sm border-[#808080] w-full mb-0">
                                {vesselInfo?.mainengine?.maker} (
                                {vesselInfo?.mainengine?.type})
                            </p>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">
                                Auxiliary Engine(s) [make & Model]:
                            </p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed text-sm border-[#808080] w-full mb-0">
                                {vesselInfo?.auxiliaryengines?.maker} (
                                {vesselInfo?.auxiliaryengines?.type})
                            </p>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0 w-4/5 print:w-3/4 print-text-sm">
                                Vessel is provided with Exhaust Gas Cleaning
                                Scrubber :
                            </p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed text-sm border-[#808080] w-1/4 mb-0">
                                {vesselInfo?.isExhauseGasCleanerScrubberProvided
                                    ? 'Yes'
                                    : 'No'}
                            </p>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">
                                Working language of the ship:
                            </p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 text-sm">
                                English
                            </p>
                        </div>
                    </div>
                </div>
                <div className="flex justify-center">
                    <div className="font-medium text-center flex flex-col mx-0 mt-4  border border-black py-2 p-6">
                        <h2 className="m-4 mb-0 text-2xl">MARPOL Annex VI </h2>
                        <span className="text-2xl">Record Book</span>
                    </div>
                </div>
                <p className="text-base font-normal text-center mb-10 mt-4">
                    (All ships)
                </p>
                <div className="flex justify-center p-1 mt-4 mb-4">
                    This entry log must be preserved on board the ship for a
                    minimum of three (3) years after the last entry has been
                    made.
                </div>
            </div>

            <div
                className={classNames({
                    'h-screen': stateOfScriptInjection === 'IDLE',
                })}
            >
                <IntroductionPage />
            </div>
            <div style={{ margin: '2rem 0' }}>
                <ItemsTobeRecorded
                    vesselInfo={vesselInfo}
                    printWithoutPageNumber={stateOfScriptInjection === 'IDLE'}
                    tanks={tanks}
                    ods={ods}
                />
            </div>
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const inspectorStore = inspectorSelectors._getStore(store);
	const marpolStore = marpolSelectors._getStore(store);
	const vesselStore = vesselSelectors._getStore(store);
	
    const tanks = marpolSelectors.getTanks(marpolStore);
	
    const stateOfScriptInjection = inspectorSelectors.getStateOfScriptInjection(inspectorStore);
    const ods = vesselSelectors.getODSData(vesselStore);

    const dateRange = inspectorSelectors.getDateRange(inspectorStore);

	const vesselInfo = vesselSelectors.getVesselById(
		ownProps.vesselId,
		vesselSelectors.getVessels(vesselStore)
	);

    return {
        vesselInfo,
        dateRange,
        tanks,
        stateOfScriptInjection,
        ods,
    };
}
const reduxConnector = connect(mapStateToProps, {});
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(Annex6V2CoverPage);
